import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import { ApiClient } from '../common/api-client.service';

interface Fund {
  id?: number,
  name: string,
}

@Component({
  templateUrl: './edit-fund.component.html'
})
export class EditFundComponent implements OnInit {
  fund: Fund = {name: null};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiClient: ApiClient,
  ) {}

  ngOnInit() {
    this.fund.id = this.route.snapshot.params['id'];
    if ( this.fund.id ) {
      this.apiClient.get<Fund>(`/api/v1/funds/${this.fund.id}`).toPromise().then(f => this.fund = f);
    }
  }

  save() {
    const save = this.fund.id ?
      this.apiClient.patch<Fund>(`/api/v1/funds/${this.fund.id}`, this.fund) :
      this.apiClient.post<Fund>('/api/v1/funds', this.fund)
    save.toPromise().then(fund => {
      // TODO success
      this.router.navigateByUrl('/')
    }, resp => {
      // TODO error
      alert(resp.error.errors);
    })
  }

  delete() {
    if ( !confirm('Are you sure you want to delete this fund?') ) { return }
    this.apiClient.delete(`/api/v1/funds/${this.fund.id}`).toPromise().then(() => {
      // TODO success
      this.router.navigateByUrl('/');
    }, resp => {
      // todo error
      alert(resp.error.errors);
    })
  }
}



// WEBPACK FOOTER //
// /srv/src/app/funds/edit-fund.component.ts